export enum ACTION {
  NEW_VARIABLE = "NEW",
  EDIT_VARIABLE = "EDIT",
  DELETE_VARIABLE = "DELETE",
}
